import React, { useState } from "react";
import "./RadioBtnv1.styles.scss";

const Radio = ({ id, label, name, onChange, ...rest }) => {
  const [isActive, setIsActive] = useState(false);

  const handleChange = (e) => {
    if (document.getElementById(`${id}`).value === label) setIsActive(true);
    else setIsActive(false);

    onChange(e);
  };
  return (
    <React.Fragment>
      <input
        {...rest}
        id={id}
        name={name}
        onChange={(e) => {
          handleChange(e);
        }}
        value={label}
        type="radio"
        style={{ marginRight: 10 }}
      />
      <label htmlFor={id} className={isActive ? "sm-label " : "sm-label"}>
        {label}
      </label>
    </React.Fragment>
  );
};
export default Radio;
